<template>
  <div v-if="rows" class="as-incident as-incident__tennis">
    <div v-if="rows" class="as-incident__head">
      <div class="as-wrapper-player">
        <PlayerTennisNew
          :team="match.home_team"
          :match="match"
          :scores="findMaxPoint.home"
          :country="getImgUrlBySport('country', match.home_team.country_id)"
        />
        <PlayerTennisNew
          :team="match.away_team"
          :match="match"
          modeTeam="away-team"
          :scores="findMaxPoint.away"
          :country="getImgUrlBySport('country', match.away_team.country_id)"
        />
      </div>
    </div>

    <div class="as-incident__list" v-if="timelines.length">
      <div
        v-for="(timeline, index) in timelines"
        :key="index"
        class="as-incident__item"
      >
        <h3
          @click="changeActiveCollapse(index.toString())"
          :class="{
            'as-active': activeCollapse === index.toString(),
          }"
        >
          <span
            >SET {{ `${timeline.set}`
            }}{{ getScoreForSet(rows.score, timeline.set) }}</span
          >
          <ArrowDown fill="#4CF446" />
        </h3>
        <div
          v-for="round in timeline.rounds"
          v-show="activeCollapse == index.toString()"
        >
          <div class="as-incident_row">
            <div class="as__left">
              <div class="as-item-left as-item-left__top" v-if="round.score">
                {{ round.score.home }}
                <div class="as__live" v-if="round.score.serve == 1">
                  <TennisLive />
                </div>
              </div>
              <div class="as-item-left as-item-left__bottom" v-if="round.score">
                {{ round.score.away }}
                <div class="as__live" v-if="round.score.serve == 2">
                  <TennisLive />
                </div>
              </div>
            </div>
            <div class="as__right">
              <div class="as-item-right as-item-right__top" v-if="round.points">
                <span
                  v-for="(point, indexPointHome) in round.points"
                  :class="getClass(round, indexPointHome, 'home')"
                  :key="indexPointHome"
                  >{{ point[0] }}</span
                >
              </div>
              <div
                class="as-item-right as-item-right__bottom"
                v-if="round.points"
              >
                <span
                  v-for="(point, indexPointAway) in round.points"
                  :class="getClass(round, indexPointAway, 'away')"
                  :key="indexPointAway"
                  >{{ point[1] }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NoData v-else />
  </div>
  <NoData v-else />
</template>

<script setup lang="ts">
import { defineProps, ref, computed } from "vue";
import { mapPlayer } from "~src/helpers/tennis";
import ArrowDown from "~src/components/icons/ArrowDown.vue";
import NoData from "~src/components/NoData.vue";
import TennisLive from "~src/components/icons/TennisLive.vue";
import PlayerTennis from "~src/components/player/PlayerTennis.vue";
import PlayerTennisNew from "~src/components/player/PlayerTennisNew.vue";
import type {
  IStatisticsJsonData,
  IMatchTennis,
  ITimeline,
  ITimelineRound,
  IHighestRanking,
  IScoreDynamic,
} from "~src/interfaces/tennis";

import {
  getMappingTimelinesOverViews,
  getScoreForSet,
} from "~src/helpers/tennis";

interface IProps {
  match: IMatchTennis;
  isPopup: boolean;
  detailShooting: any;
  overviews: IStatisticsJsonData[];
}

const props = withDefaults(defineProps<IProps>(), {
  isPopup: true,
});

const findMaxPoint = computed<any>(() => {
  const _row = rows.value;
  const _match = props.match;

  let homeRanking = "0";
  let awayRanking = "0";
  if (_row?.score) {
    const scoreDynamic = _row?.score?.[3] as IScoreDynamic | undefined;
    if (scoreDynamic && scoreDynamic.pt) {
      homeRanking = scoreDynamic.pt[0];
      awayRanking = scoreDynamic.pt[1];
    }
  }

  return {
    home: homeRanking || 0,
    away: awayRanking || 0,
  };
});

const rows = computed<IStatisticsJsonData>(() => {
  const __rows = props.overviews.length
    ? props.overviews[props.overviews.length - 1]
    : ({} as IStatisticsJsonData);

  return __rows;
});

const timelines = computed<ITimeline[]>(() => {
  const rowData = rows.value;
  let __timeline = rowData.timeline ?? ([] as ITimeline[]);
  __timeline = getMappingTimelinesOverViews(__timeline);
  return __timeline;
});

// player1Score: Điểm số của người chơi 1 (home).
// player2Score: Điểm số của người chơi 2 (away).
// pointsArray: Mảng chứa tất cả các pha (points) của game hiện tại.
// currentPointIndex: Chỉ số của pha hiện tại trong mảng pointsArray.
// checkingPlayer: Người chơi đang được kiểm tra điều kiện (1 cho người chơi 1, 2 cho người chơi 2).
const isWinningPointCondition = function (
  player1Score: any,
  player2Score: any,
  pointsArray: any,
  currentPointIndex: any,
  checkingPlayer: any
) {
  // Nếu đang ở điểm đầu tiên (chỉ số bằng 0)
  if (currentPointIndex === 0) {
    return (
      (player1Score > player2Score && checkingPlayer === 1) ||
      (player1Score < player2Score && checkingPlayer === 2)
    );
  }

  // Kiểm tra điều kiện lợi thế
  if (
    (player1Score === "A" && checkingPlayer === 1) ||
    (player2Score === "A" && checkingPlayer === 2)
  ) {
    return true;
  }

  // Lấy điểm số của pha trước đó
  const previousPlayer1Score = pointsArray[currentPointIndex - 1][0];
  const previousPlayer2Score = pointsArray[currentPointIndex - 1][1];

  // So sánh điểm số giữa người chơi 1 và người chơi 2
  if (player1Score !== player2Score) {
    return (
      (player1Score !== previousPlayer1Score && checkingPlayer === 1) ||
      (player2Score !== previousPlayer2Score && checkingPlayer === 2)
    );
  } else if (player1Score === "40" && player2Score === "40") {
    if (previousPlayer1Score === "A") {
      return checkingPlayer === 2;
    } else if (previousPlayer2Score === "A") {
      return checkingPlayer === 1;
    }
    return (
      (player1Score !== previousPlayer1Score && checkingPlayer === 1) ||
      (player2Score !== previousPlayer2Score && checkingPlayer === 2)
    );
  } else {
    return (
      (player1Score !== previousPlayer1Score && checkingPlayer === 1) ||
      (player2Score !== previousPlayer2Score && checkingPlayer === 2)
    );
  }
};

// player1Score: Điểm số của người chơi 1 (home).
// player2Score: Điểm số của người chơi 2 (away).
// servingPlayer: Người chơi hiện đang giao bóng (1 cho người chơi 1, 2 cho người chơi 2).
// checkingPlayer: Người chơi cần kiểm tra điều kiện (1 cho người chơi 1, 2 cho người chơi 2).
const checkAdvantageCondition = function (
  player1Score: any,
  player2Score: any,
  servingPlayer: number,
  checkingPlayer: number
) {
  // Kiểm tra nếu người chơi 1 (home) đang giao bóng và kiểm tra người chơi 2 (away)
  if (servingPlayer === 1 && checkingPlayer === 2) {
    return (
      player2Score === "A" || // Người chơi 2 có điểm lợi thế
      (player2Score === "40" && // Người chơi 2 có điểm "40"
        player1Score !== "40" && // Người chơi 1 không có điểm "40"
        player1Score !== "A") // Người chơi 1 không có điểm lợi thế
    );
  }

  // Kiểm tra nếu người chơi 2 (away) đang giao bóng và kiểm tra người chơi 1 (home)
  if (servingPlayer === 2 && checkingPlayer === 1) {
    return (
      player1Score === "A" || // Người chơi 1 có điểm lợi thế
      (player1Score === "40" && // Người chơi 1 có điểm "40"
        player2Score !== "40" && // Người chơi 2 không có điểm "40"
        player2Score !== "A") // Người chơi 2 không có điểm lợi thế
    );
  }

  // Mặc định trả về false nếu không thỏa mãn các điều kiện trên
  return false;
};

const getClass = (round: any, index: number, type = "home") => {
  const points: any = round.points;
  const homeScore = points[index][0];
  const awayScore = points[index][1];
  const checkAdvantage = checkAdvantageCondition(
    homeScore,
    awayScore,
    round.score && round.score.serve ? round.score.serve : 1,
    type == "home" ? 1 : 2
  );
  if (checkAdvantage) {
    return "as__green";
  }

  const isWinning = isWinningPointCondition(
    homeScore,
    awayScore,
    points,
    index,
    type == "home" ? 1 : 2
  );
  if (isWinning) {
    return "as__white";
  }

  return "";
};

const activeCollapse = ref("0");

const changeActiveCollapse = (index: any) => {
  if (activeCollapse.value === index) {
    activeCollapse.value = "";
  } else {
    activeCollapse.value = index;
  }
};
</script>

<script lang="ts">
export default {};
</script>
